interface IconProps {
  className?: string;
}

const ChevronDownIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        d="m4 6 4.5 4.5L13 6"
      ></path>
    </svg>
  );
};

export default ChevronDownIcon;
